import { useState } from "react";
import { toast } from "sonner";
import {  Input, Textarea } from "./ui";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@radix-ui/react-select";
import { Button } from "./ui/Button";
import { useSubmitEnquiry } from "../hooks/useEnquiry";

const EnquirySection = () => {
	const [formData, setFormData] = useState({
		name: "",
		phone: "",
		email: "",
		age: "",
		course: "",
		message: "",
	});

	const submitEnquiry = useSubmitEnquiry();

	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			await submitEnquiry.mutateAsync(formData);
			toast.success("Thank you for your enquiry! We will contact you soon. 🙏", {
				duration: 5000,
			});
			setFormData({ name: "", phone: "", email: "", age: "", course: "", message: "" });
		} catch (err) {
			toast.error("Failed to submit enquiry. Please try again.", {
				duration: 4000,
			});
		}
	};

	return (
		<section id="enquiry" className="py-24 px-4 bg-background">
			<div className="max-w-2xl mx-auto">
				<div className="text-center mb-12">
					<p className="text-accent font-heading text-lg tracking-widest uppercase mb-2">Get in Touch</p>
					<h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4">
						Enquire Now
					</h2>
					<div className="w-24 h-1 bg-accent mx-auto rounded-full" />
				</div>

				<form
					onSubmit={handleSubmit}
					className="bg-card border-2 border-gold/30 rounded-xl p-8 md:p-10 shadow-gold space-y-5"
				>
					<div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
						<Input
							placeholder="Your Name"
							value={formData.name}
							onChange={(e) => setFormData({ ...formData, name: e.target.value })}
							required
							className="bg-background border-border focus:border-accent"
						/>
						<Input
							placeholder="Phone Number"
							type="tel"
							value={formData.phone}
							onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
							required
							className="bg-background border-border focus:border-accent"
						/>
					</div>
					<div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
						<Input
							placeholder="Email Address"
							type="email"
							value={formData.email}
							onChange={(e) => setFormData({ ...formData, email: e.target.value })}
							className="bg-background border-border focus:border-accent"
						/>
						<Input
							placeholder="Age"
							type="number"
							value={formData.age}
							onChange={(e) => setFormData({ ...formData, age: e.target.value })}
							className="bg-background border-border focus:border-accent"
						/>
					</div>
					<Select
						value={formData.course}
						onValueChange={(val) => setFormData({ ...formData, course: val })}
					>
						<SelectTrigger className="bg-background border-border focus:border-accent">
							<SelectValue placeholder="Select Course" />
						</SelectTrigger>
						<SelectContent>
							<SelectItem value="bharatanatyam">Bharatanatyam</SelectItem>
							<SelectItem value="tabla">Tabla</SelectItem>
							<SelectItem value="art">Art</SelectItem>
							<SelectItem value="guitar">Guitar</SelectItem>
							<SelectItem value="singing">Singing</SelectItem>
						</SelectContent>
					</Select>
					<Textarea
						placeholder="Your Message (optional)"
						value={formData.message}
						onChange={(e) => setFormData({ ...formData, message: e.target.value })}
						rows={4}
						className="bg-background border-border focus:border-accent"
					/>
					<Button variant="gold" size="lg" type="submit" className="w-full text-lg py-6">
						Submit Enquiry
					</Button>
				</form>
			</div>
		</section>
	);
};

export default EnquirySection;
